
import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { HelpCircle, CreditCard, Shield, BarChart3, Lock, Mail } from 'lucide-react';

const FAQ = () => {
  const faqItems = [
    {
      question: "Vad ingår i prisplanerna?",
      answer: "Våra prisplaner inkluderar tillgång till vår AI-drivna analysmotor, anbudssökning, dokumentanalys och automatiserad upphandlingsbevakning. Antalet aktiva upphandlingar och användarkonton varierar beroende på vilken plan du väljer.",
      icon: <HelpCircle className="h-4 w-4 text-yellow-500" />
    },
    {
      question: "Hur fungerar faktureringen?",
      answer: "Faktureringen sker månadsvis och baseras på den plan du har valt. Du kan när som helst uppgradera eller nergradera din plan om dina behov ändras. För årliga abonnemang erbjuder vi en rabatt på 20%.",
      icon: <BarChart3 className="h-4 w-4 text-yellow-500" />
    },
    {
      question: "Vilka betalningsmetoder accepterar ni?",
      answer: "Vi accepterar alla större kreditkort, debetkort och andra betalningsalternativ som banköverföring. För företagskunder erbjuder vi även fakturering med 30 dagars betalningsvillkor.",
      icon: <CreditCard className="h-4 w-4 text-yellow-500" />
    },
    {
      question: "Finns det några kostnader för installation eller onboarding?",
      answer: "Nej, vi tar inte ut några avgifter för grundläggande onboarding till plattformen. För Business- och Enterprise-planerna ingår personlig implementering och utbildning.",
      icon: <Shield className="h-4 w-4 text-yellow-500" />
    },
    {
      question: "Kan jag prova systemet innan jag bestämmer mig?",
      answer: "Ja, vi erbjuder en kostnadsfri provperiod på 14 dagar för alla våra planer. Under denna period får du full tillgång till funktionerna i den plan du har valt, inklusive analys av upp till 5 upphandlingar.",
      icon: <Lock className="h-4 w-4 text-yellow-500" />
    },
    {
      question: "Hur kontaktar jag support om jag har problem?",
      answer: "För alla planer erbjuder vi support via e-post och vårt kunskapscenter. Business- och Enterprise-kunder har tillgång till prioriterad support via telefon och en dedikerad kundansvarig.",
      icon: <Mail className="h-4 w-4 text-yellow-500" />
    }
  ];

  return (
    <div className="container mx-auto px-4 sm:px-6">
      <div className="text-center max-w-3xl mx-auto mb-8">
        <h2 className="text-2xl font-montserrat font-bold mb-2 text-yellow-500">
          Vanliga frågor
        </h2>
      </div>
      
      <div className="max-w-2xl mx-auto">
        <Accordion type="single" collapsible className="w-full">
          {faqItems.map((item, index) => (
            <AccordionItem key={index} value={`item-${index}`} className="border-b border-yellow-300/30">
              <AccordionTrigger className="py-4 text-left hover:text-accent transition-colors">
                <div className="flex items-center">
                  <span className="mr-3">
                    {item.icon}
                  </span>
                  <span className="font-montserrat font-medium text-sm text-darkgray/90">
                    {item.question}
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="pb-4 pl-9 pr-4 text-darkgray/70 text-xs font-opensans">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
      
      <div className="mt-6 text-center">
        <p className="text-darkgray/70 text-sm mb-4 font-opensans">Har du fortfarande frågor?</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button className="btn-secondary text-sm px-4 py-1.5">Boka en demo</button>
          <button className="btn-tertiary text-sm px-4 py-1.5">Kontakta säljare</button>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
